import { combineReducers } from 'redux';
import { activeDialog } from './active-dialog';
export const reducer = combineReducers({
    activeDialog,
});
export default {
    activeDialog,
};
